/* Sleep Cult — comparison tables.
   Under 760px each table shows one competitor at a time; the picker writes the
   chosen column index onto the scroller's data-sel and CSS hides the rest
   (0 = show all four and swipe). Delegated from the document so tables added
   or re-rendered by the theme editor keep working without re-binding. */
(function () {
  // Each table section links this file; bind the delegate only once.
  if (window.__scComparisonTable) return;
  window.__scComparisonTable = true;

  document.addEventListener('change', function (event) {
    var select = event.target.closest('.cmp-chips__select');
    if (!select) return;

    var scroller = document.getElementById(select.getAttribute('aria-controls'));
    if (!scroller) return;

    scroller.setAttribute('data-sel', select.value);
    // Swipe-all restores the wide table; start it back at the left edge so the
    // spec column is what the reader lands on.
    if (select.value === '0') scroller.scrollLeft = 0;
  });
})();
